"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPreviousYearMatchingDay = void 0;
const dayjs = require("dayjs");
const weekOfYear = require("dayjs/plugin/weekOfYear");
dayjs.extend(weekOfYear);
const isoWeek = require("dayjs/plugin/isoWeek");
dayjs.extend(isoWeek);
const getPreviousYearMatchingDay = (inputDate, year_offset) => {
    const date = dayjs(inputDate);
    const dayOfWeek = date.isoWeekday();
    const month = date.month();
    const year = date.year() - year_offset;
    let previousYearDate = dayjs(new Date(year, month, date.date()));
    // If the exact date does not exist in the previous year (e.g., February 29 in a non-leap year)
    // adjust the date to the closest valid date in the same month
    if (previousYearDate.month() !== month) {
        previousYearDate = dayjs(new Date(year, month + 1, 0)); // Last day of the same month
    }
    // Find the nearest matching day of the week
    let closestDate = previousYearDate;
    let minDiff = Math.abs(previousYearDate.isoWeekday() - dayOfWeek);
    for (let i = -6; i <= 6; i++) {
        const testDate = previousYearDate.add(i, "day");
        if (testDate.month() === month) {
            const diff = Math.abs(testDate.isoWeekday() - dayOfWeek);
            if (diff < minDiff) {
                closestDate = testDate;
                minDiff = diff;
            }
        }
    }
    return closestDate.format("YYYY-MM-DD");
};
exports.getPreviousYearMatchingDay = getPreviousYearMatchingDay;
